import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from 'web-library';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  typography: {
    display: 'inline',
  },
}));

const EXAM_LEVELS = [
  {
    id: 0,
    label: 'PSLE',
    code: 'PSLE',
  },
  {
    id: 1,
    label: 'GCE N-Level',
    code: 'GCEN',
  },
  {
    id: 2,
    label: 'GCE O-LEVEL',
    code: 'GCEO',
  },
  {
    id: 3,
    label: 'GCE A-LEVEL',
    code: 'GCEA',
  },
  {
    id: 4,
    label: 'IPSLE',
    code: 'IPSLE',
  },
];

const links = {
  o:
    'https://isomer-user-content.by.gov.sg/334/566b6637-ccbb-42ed-aaa1-570023785ac0/O_Level_Explanatory_Notes.pdf',
  a:
    'https://isomer-user-content.by.gov.sg/334/b72346f7-8ad6-44f7-854a-19ca53d1ce65/A_Level_Explanatory_Notes.pdf',
  nt:
    'https://isomer-user-content.by.gov.sg/334/87be230f-487a-4091-96d8-104fd69e5bd6/N_T__Level_Explanatory_Notes.pdf',
  na:
    'https://isomer-user-content.by.gov.sg/334/36913f3c-fe04-4957-b21b-9dfcdccdaf83/N_A__Level_Explanatory_Notes.pdf',
  psle: 'https://go.gov.sg/psle-explanatory-notes',
  ipsle: 'https://go.gov.sg/ipslecertificateexplanatorynote',
};

const getLink = (examLevel: string, examCode: string | undefined) => {
  if (examCode && examCode === EXAM_LEVELS[4].code) {
    return links.ipsle;
  }

  switch (examLevel) {
    case EXAM_LEVELS[2].label:
      return links.o;
    case EXAM_LEVELS[3].label:
      return links.a;
    default:
      return links.psle;
  }
};

export interface IndividualResultReleaseProps {
  examLevel: string;
  examCode?: string;
}

const ResultSlipExplanitory = ({ examLevel, examCode }: IndividualResultReleaseProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const resultSlipOneText = t('exam->>ResultDetail.ResultSlip1');
  const resultSlipOneLink = t('exam->>ResultDetail.ResultSlipLink');
  if (examLevel === EXAM_LEVELS[1].label) {
    return (
      <>
        <Typography className={classes.typography} variant="caption">
          {resultSlipOneText}
        </Typography>
        <Link target="_blank" href={links.nt} rel="noopener noreferrer">
          <Typography className={classes.typography} variant="caption">
            {resultSlipOneLink}
          </Typography>
        </Link>
        <Typography className={classes.typography} variant="caption">
          {t('exam->>ResultDetail.ResultSlip2NT')}
        </Typography>
        <br />
        <Typography className={classes.typography} variant="caption">
          {' '}
          {resultSlipOneText}
        </Typography>
        <Link target="_blank" href={links.na} rel="noopener noreferrer">
          <Typography className={classes.typography} variant="caption">
            {resultSlipOneLink}
          </Typography>
        </Link>
        <Typography className={classes.typography} variant="caption">
          {t('exam->>ResultDetail.ResultSlip2NA')}
        </Typography>
      </>
    );
  }
  return (
    <>
      <Typography className={classes.typography} variant="caption">
        {resultSlipOneText}
      </Typography>
      <Link target="_blank" href={getLink(examLevel, examCode)} rel="noopener noreferrer">
        <Typography className={classes.typography} variant="caption">
          {resultSlipOneLink}
        </Typography>
      </Link>
      <Typography className={classes.typography} variant="caption">
        {t('exam->>ResultDetail.ResultSlip2')}
      </Typography>
    </>
  );
};

export default ResultSlipExplanitory;
